import { cx } from 'class-variance-authority'
import React from 'react'
import { BaseCarousel } from '../../../base/baseCarousel/BaseCarousel'
import { FirmTeaser, TeaserProps } from '../../../firms/teaser'
import { TeaserFirmSkeleton } from '../../../ui/skeleton/teaserFirmSkeleton'

export const FirmCarousel = ({ firms = [] }: { firms: TeaserProps[] }) => (
  <BaseCarousel
    LoaderComponent={<TeaserFirmSkeleton />}
    nbDefaultItems={200}
    isLoading={!firms || firms.length === 0}
    containerClassNames="my-8"
  >
    {firms.map(
      (
        {
          name,
          logo,
          header,
          city,
          nbOffices,
          nbTotalOffers,
          totalEmployees,
          url,
          subscriptionType,
        },
        index,
      ) => (
        <li
          key={index}
          className={cx(
            'w-[273px] h-[350px] mt-2 mb-12 list-none flex-1',
            index === 0 && 'ml-12',
          )}
        >
          <FirmTeaser
            name={name}
            logo={logo}
            header={header}
            city={city}
            nbTotalOffers={nbTotalOffers}
            nbOffices={nbOffices}
            totalEmployees={totalEmployees}
            url={url}
            subscriptionType={subscriptionType}
          />
        </li>
      ),
    )}
  </BaseCarousel>
)
